// src/components/Payment/PaymentCancel.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaypalPaymentCancel = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h2>Payment Cancelled</h2>
            <button onClick={() => navigate('/')}>Return to Home</button>
        </div>
    );
};

export default PaypalPaymentCancel;
